import { config } from "../config";
import HttpService from "./httpService";

export const ADDRESS_AUTOCOMPLETE_ENDPOINT = "/address/api/autocomplete";
export const PLACE_DETAILS_ENDPOINT = "/address/api/places";

export interface PlacePrediction {
  placeId: string;
  text?: {
    text?: string;
  };
  structuredFormat?: {
    mainText?: {
      text?: string;
    };
    secondaryText?: {
      text?: string;
    };
  };
}

interface AutocompleteResponse {
  suggestions?: Array<{
    placePrediction?: PlacePrediction;
  }>;
}

interface PlaceAddressComponent {
  longText?: string;
  shortText?: string;
  types?: string[];
}

export interface PlaceDetailsResponse {
  formattedAddress?: string;
  addressComponents?: PlaceAddressComponent[];
}

export const createPlacesHttpService = (): HttpService =>
  new HttpService(config.apiUrl.replace(/\/$/, ""));

export const getAddressPredictions = async (
  httpService: HttpService,
  input: string,
  countryCode: string,
  sessionToken: string
): Promise<PlacePrediction[]> => {
  const response = await httpService.post<AutocompleteResponse>(
    ADDRESS_AUTOCOMPLETE_ENDPOINT,
    {
      input,
      includedRegionCodes: [countryCode.toLowerCase()],
      sessionToken,
    },
    { "content-type": "application/json" }
  ) as AutocompleteResponse;

  return (response.suggestions ?? [])
    .map((suggestion) => suggestion.placePrediction)
    .filter((prediction): prediction is PlacePrediction => Boolean(prediction?.placeId));
};

export const getPlaceDetails = (
  httpService: HttpService,
  placeId: string,
  sessionToken: string
): Promise<PlaceDetailsResponse> =>
  httpService.get(
    `${PLACE_DETAILS_ENDPOINT}/${encodeURIComponent(placeId)}?sessionToken=${encodeURIComponent(sessionToken)}`
  );

export const toLegacyGooglePlace = (details: PlaceDetailsResponse) => ({
  formatted_address: details.formattedAddress ?? "",
  address_components: (details.addressComponents ?? []).map((component) => ({
    long_name: component.longText ?? "",
    short_name: component.shortText ?? component.longText ?? "",
    types: component.types ?? [],
  })),
});
